import { FormStore } from 'form/reflux/form_store';
import FormGroupFactory from 'form/models/group/form_group_factory';
import { FormAPI, FormActionAPI, BaseAPI, FlashMessageAPI } from 'lecom-api';
import { formatFieldValue, formatFieldNumericValue } from '../../../form/helpers/field_value_formatter';
import FormFieldTypes from '../../../form/constants/form_field_types';
import { getClassProperties } from 'utils/object_utils';
import { generateUUID } from 'utils/uuid';
import DateUtils from 'utils/date_utils';
import FormFieldAPI from '../field/form_field_api';
import FormGroupItem from 'form/models/group/form_group_item';

import FormFieldAPIFactory from '../field/form_field_api_factory';

/**
* @extends FormGroupAPI
*/

class FormGroupAPI extends BaseAPI {
    _formId;
	_identifier;
    _name;
    _fields;
    _gridId;
	_isGridField;
	_expansible;

	static groupProperties() {
		return getClassProperties(FormGroupItem)
			.filter((p) => ['id', 'name', 'expansible', 'fields', 'grids', 'actions', 'errors'].indexOf(p) === -1);
	}

    /**
	* @constructor
	* @param {*} param0
	*/

    constructor({id, identifier,  name, expansible, storeId, formId,  fieldsId, gridId, applyMode = FormAPI.applyMode, isGridField = false}) {
		super({id, identifier, name, expansible, storeId, formId, fieldsId, gridId, applyMode, storeClass: FormStore });

		//this._fields = null;
		this._identifier = identifier;
		this._name = name;
		this._expansible = expansible;

		this._formId = formId;
		//this._gridId = gridId;
		this._isGridField = isGridField;

        FormGroupAPI.groupProperties().forEach((groupProperty) => {
			this[groupProperty] = this._propertyAccessor.bind(this, groupProperty);
		});
	}

	name(name) {
		if (!name && name !== '')
			return this._name;

		//todo set name
		const spanGroup = $(`#group-name_${this._id} span`);
		spanGroup.text(name);
		this._name = name;

		return this;
	}

	expansible(expansible){
		if(this._expansible === false && expansible === true ){
			let divGroup = $(`#group-name_${this._id}`);
			let btnExpansible = $(`#group-name_${this._id} i`);

			this._expansible = expansible;

			divGroup.addClass('expansible');
			btnExpansible.removeClass('not-expansible');
			btnExpansible.addClass('expansible-group');

			return this;

		} else if(this._expansible === true && expansible === false){
			let group = $(`.group-${this._id}`);
			let divGroup = $(`#group-name_${this._id}`);
			let btnExpansible = $(`#group-name_${this._id} i`);

			this._expansible = expansible;

			divGroup.removeClass('expansible');
			btnExpansible.addClass('not-expansible');

			return this;

		} else if(this._expansible === expansible ){

			return this._expansible , this;
		} else {
			return this._expansible;
		}
	}


	/**
	 *
	 * @param {*} fieldId
	 */
	fields(fieldId) {
		if (!this._fields) {
			this._fields = this._buildFieldsAPIs();
		}

		if(fieldId){
			const idGroup = this._id;
			const fieldGroupId = this._fields[fieldId].fieldGroupingId() ;

			if(fieldGroupId === idGroup){
				return fieldId ? this._fields[fieldId] : Object.keys(this._fields).map(field => this._fields[field]);
			} else {
				console.warn(Realize.i18n.t('groupWithoutField'));
				return
			}
		} else {
			this._fields = this._buildFieldsAPIs();
			const idGroup = this._id;
			const fieldsGroup = Object.keys(this._fields).map(field => this._fields[field]);

			//retorna os campos pertencentes ao grupo informado
			return fieldsGroup.filter(field => field.fieldGroupingId() === idGroup )
		}
	}

	grids(gridId){
		this._fields = this._buildFieldsAPIs();
		const idGroup = this._id;
		const gridsGroups = Object.keys(this._fields).map(field => this._fields[field]);
		const typeFieldsGrid = gridsGroups.filter(field => field.type() === 'GRID');
		const grids = typeFieldsGrid.filter(field => field.fieldGroupingId() === idGroup);

		if (gridId !== undefined && gridId !== null && gridId !== ""){
			return grids.find(grid => grid.id === gridId);
		} else {
			return grids;
		}
	}

	subscribe(){
		console.warn(Realize.i18n.t('warningEventSubscribeGroup'));
		return this
	}

	expanded(expand){
		const idGroup = this._id;
		const expanded = this._expansible;
		const currentGroup = $(`#group-name_${idGroup}`);
		const currentGroupHide = $(`#group-fields_${idGroup}`).css("display") === 'none';

		// if (expanded !== false) {
			if(expand === currentGroupHide) {
				currentGroup.trigger('click');

				setTimeout(() => {
					if(!expand && $(`#group-fields_${idGroup}`).css("display") === "block") {
						currentGroup.trigger('click');
					}else if(expand && $(`#group-fields_${idGroup}`).css("display") === "none") {
						currentGroup.trigger('click');
					}
				},0);
			}

			return this;
		// }
		// else {
		// 	console.warn(Realize.i18n.t('warningExpandedGroup'));
		// }

		return this;
	}

	disabled(value){
		const idGroup = this._id;
		const groupBorder = $(`#group-border_${idGroup}`);
		const groupName = $(`#group-name_${idGroup}`);

		if(value === undefined){
			return this.get('disabled');
		}

		this.fields().forEach(element => {
			element.disabled(value).apply();
		});

		if(value !== false){
			groupBorder.addClass('group-border-desabled');
			groupName.addClass('group-name-disabled');
		} else {
			groupBorder.removeClass('group-border-desabled');
			groupName.removeClass('group-name-disabled');
		}

		FormAPI.form(this._formId).apply();

		return this.set({disabled: value});
	}

	visible(value) {
		const idGroup = this._id;
		const groupFields = $(`#group-fields_${idGroup}`);
		const groupBorder = $(`#group-border_${idGroup}`);
		const groupName = $(`#group-name_${idGroup}`);

		if(value === undefined){
			let identifier = this._identifier;
			let groupVisible = $(`#${identifier}:visible`);

			if(groupFields.hasClass("hide") === false && groupVisible === false)
				return groupVisible
			else
				return !groupFields.hasClass("hide");
		}

		this.fields().forEach(element => {
			element.visible(value);
		});

		if(value === false){
			groupFields.addClass('hide');
			groupBorder.addClass('hide');
			groupName.addClass('hide');
		} else {
			groupFields.removeClass('hide');
			groupBorder.removeClass('hide');
			groupName.removeClass('hide');
		}

		if(value !== undefined) {
            if(!window[this._identifier]) window[this._identifier] = {};
			window[this._identifier].isVisible = value;
        }

		FormAPI.form(this._formId).apply();
		return this.set({visible: value});
	}

	_buildFieldsAPIs() {
		var fields = this.get('fields');
		var returnFields = { };

		for (let field in fields) {
			if (fields[field].component === 'gridform') {
				returnFields[field] = FormFieldAPIFactory.create(fields[field], {
					formId: this._formId || fields[field].formId,
					fieldGroupingId: fields[field].fieldGroupingId,
					storeId: this.storeId,
					applyMode: this.applyMode,
					type: fields[field].type
				});
			}
			else {
				returnFields[field] = FormFieldAPIFactory.create(fields[field], {
					formId: this._formId || fields[field].formId,
					fieldGroupingId: fields[field].fieldGroupingId,
					storeId: this.storeId,
					applyMode: this.applyMode,
				});
			}
		}

		return returnFields;
	}
}

export default FormGroupAPI;
